export { default } from './ButtonGoTo';
